import classNames from 'classnames'

import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './ImageRelative.module.css'

export interface ImageRelativeProps {
  image: ImageProps
  imageCaption?: string
  altText?: string
  marginBottom?: boolean
  includeOriginalRes?: boolean
}

export default function ImageRelative({
  image,
  imageCaption,
  altText,
  marginBottom = true,
  includeOriginalRes = false,
}: ImageRelativeProps) {
  return (
    <div
      className={classNames(styles.media, marginBottom && styles.marginBottom)}
    >
      <div className={styles.mediaImage}>
        <Image
          asset={image.asset}
          objectFit="cover"
          alt={altText || imageCaption || 'Report Image'}
          sizes={includeOriginalRes ? `` : `(max-width: 799px) 80vw, 50vw`}
          priority={true}
        />
      </div>
      {imageCaption && (
        <Text
          size={TextSizes.magSecondaryBodySml}
          className={styles.imageCaption}
        >
          <span dangerouslySetInnerHTML={{ __html: imageCaption }} />
        </Text>
      )}
    </div>
  )
}
